<div class="form-group-query">
    <div [style]="props['labelstyle']" [title]="tooltip">
        <label>{{to.label + " " + getConditionTypeName()}}</label>
    </div>
    <div style="margin-left:10px">
        <input (click)="manageCheck();$event.preventDefault();" type="checkbox" [checked]="isChecked" />
    </div>
    <div style="margin-left:10px" (keydown.enter)="openModal()" *ngIf="isfreetext == false">
        <input (ngModelChange)="onInputChange()" class="ml-5 form-control" type="text" [formControl]="formControl" [formlyAttributes]="field" #value appRenderWidth (paste)="onPaste($event)"/>
    </div>
    <div style="margin-left:10px" *ngIf="isfreetext == true">
        <input (ngModelChange)="onInputChange()" class="ml-5 form-control" type="text" [formControl]="formControl" [formlyAttributes]="field" #value appRenderWidth (paste)="onPaste($event)"/>
    </div>
    <div style="max-width: 500px;">
        <span style="margin-left:15px">{{ text }}</span>
    </div>
</div>